import { AppLinks } from "../links";
import { useContainer } from "./useContainer";

export const useLinks = (): AppLinks => useContainer().links;
